import React, { useEffect, useRef, useState } from 'react'
import styles from './notifications.module.scss';
import notificationIcon from '../../assets/images/extras/notification-alert.png'
import { useDispatch } from 'react-redux';
import { closeNotification } from '../../store/Partner/modalSlice';
function Notifications() {
    const modalRef = useRef(null);
    const dispatch = useDispatch()
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target) && !event.target.classList.contains('notification')) {
                dispatch(closeNotification())
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const [notification, setNotification] = useState(
        [
            {
                category: 'Today',
                notifications: [
                    { id: 1, data: 'Notification Data', url: '' },
                    { id: 1, data: 'Data', url: '' },
                    { id: 1, data: 'Notification Data', url: '' },
                ]
            },
            {
                category: 'Previous Notifications',
                notifications: [
                    { id: 1, data: 'Data nhi pta bhai', url: '' },
                    { id: 1, data: 'Pta hai bhai', url: '' },
                    { id: 1, data: 'Are kya pta hai bhai', url: '' },
                ]
            }
        ]
    )

    return (
        <div className={styles.notificationContainer} ref={modalRef}>
            <div className={styles.notificationHeader}>
                <h3>Notification</h3>
            </div>
            <div className={styles.notificationBody}>
                {/* <div className={styles.notificationCategory}>
                    <div className={styles.categoryHeader}>
                        <h4 className={styles.categoryHeading}>Today</h4>
                    </div>
                    <div className={styles.categoryBody}>
                        <p className={styles.notification}>
                        Data nhi pta bhai 
                        </p>

                        <p className={styles.notification}>
                        Data nhi pta bhai Lorem, ipsum dolor sit amet est quasi aliquid molestias necessitatibus animi repudiandae asperiores in?
                        </p>
                    </div>
                </div> */}
                <div className={styles.noNotificationData}>
                    <span className={styles.icon}>
                        <img src={notificationIcon} alt="" />
                    </span>
                    <p>No New notifications</p>
                </div>

            </div>

            <div className={styles.btnOptions}>
                <button>Mark all as read</button>
            </div>
        </div>
    )
}

export default Notifications